import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { normalizePhone } from '@mssgme/helpers';
import { FieldRow, Input, useFormikContext } from '@mssgme/ui';
import { SelectMessengerType } from '../../../UI';

export default function NameField({ name, ...rest }) {
    const {
        getFieldProps,
        setFieldValue,
        setFieldTouched,
        values: { type, messenger },
    } = useFormikContext();

    const handleChange = useCallback(
        (e) => {
            let { value } = e.target;
            if ((messenger === 'viber' || messenger === 'whatsapp') && type === 'private') {
                value = normalizePhone(value);
            }
            setFieldValue(name, value);
            setFieldTouched(name, true, false);
        },
        [setFieldValue, setFieldTouched, type, messenger]
    );

    let beforeInput;
    switch (messenger) {
        case 'messenger':
            beforeInput = 'm.me/';
            break;
        case 'vk':
            beforeInput = 'vk.me/';
            break;
        case 'viber':
        case 'whatsapp':
            beforeInput = <SelectMessengerType platform={messenger} {...getFieldProps('type')} />;
            break;
    }

    return <FieldRow as={Input} name={name} onChange={handleChange} beforeInput={beforeInput} {...rest} />;
}

NameField.propTypes = {
    name: PropTypes.string.isRequired,
};
